


























































import Vue from 'vue'
import zip from 'lodash/zip'

import { wrapVariables } from '@/utils'
import { AllActiveTasks, MyActiveTasks } from '@/queries/tasks.graphql'
import {
  TaskNodeFragment,
  ShortTaskNodeFragment,
  AllActiveTasksQuery,
  MyTaskLogsOrderBy,
} from '@/graphql-schema'
import { CompleteTaskAction, FetchAction } from '@/store/workflow/actions'
import { VariablePayload } from '@/store/workflow/types'

type Column = 'case' | 'caseId' | 'inCharge' | 'name' | 'due'

export interface ComponentData {
  refreshInterval: number
  page: number
  pageSize: number
  sortBy: Column | null
  sortDesc: boolean
  activeTasks: AllActiveTasksQuery['activeTasks']
  selectedTask: TaskNodeFragment | null
  fields: any[]
  onlyMine: boolean
  sortCompare: (...args: any[]) => number
}

function compareStrings(
  a?: string | null,
  b?: string | null,
  locales?: string | string[],
  options?: Intl.CollatorOptions
): number {
  if (!a && !b) {
    return 0
  } else if (!b) {
    return 1
  } else if (!a) {
    return -1
  } else {
    return a.localeCompare(b, locales, options)
  }
}

function compareDates(
  a?: Date | null,
  b?: Date | null,
  options: { nulls?: 'first' | 'last' } = { nulls: undefined }
): number {
  if (!a && !b) {
    return 0
  } else if (!b) {
    return 1
  } else if (!a) {
    return -1
  } else {
    return a < b ? -1 : a > b ? 1 : 0
  }
}

interface TaskNodeItem extends TaskNodeFragment {
  _rowVariant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'danger'
    | 'info'
    | 'light'
    | 'dark'
}

export default Vue.extend({
  apollo: {
    activeTasks: {
      query() {
        return this.onlyMine ? MyActiveTasks : AllActiveTasks
      },
      fetchPolicy: 'no-cache',
      pollInterval: 60 * 1000 /* ms */,
      variables() {
        return {
          first: this.first,
          offset: this.offset,
          orderBy: this.orderBy,
        }
      },
    },
  },
  computed: {
    first(): number {
      return this.pageSize
    },
    offset(): number {
      return this.page * this.pageSize
    },
    orderBy(): MyTaskLogsOrderBy[] {
      if (this.sortBy === 'due') {
        return [this.sortDesc ? MyTaskLogsOrderBy.DueDesc : MyTaskLogsOrderBy.DueAsc]
      } else if (this.sortBy === 'name') {
        return [this.sortDesc ? MyTaskLogsOrderBy.NameDesc : MyTaskLogsOrderBy.NameAsc]
      } else {
        return [MyTaskLogsOrderBy.Natural]
      }
    },
    rows(): ShortTaskNodeFragment[] {
      const now = new Date()
      if (this.activeTasks) {
        return this.activeTasks.nodes.map(t => ({
          ...t,
          _rowVariant: t.due && new Date(t.due) < now ? 'danger' : undefined,
        }))
      } else {
        return []
      }
    },
  },
  /*
  created() {
    this.refreshTaskList()
    this.refreshInterval = window.setInterval(() => this.refreshTaskList(), 60 * 1000)
  },
  beforeDestroy() {
    window.clearInterval(this.refreshInterval)
  },
  */
  data(): ComponentData {
    return {
      refreshInterval: 0,
      page: 0,
      pageSize: 100,
      sortBy: null,
      sortDesc: false,
      selectedTask: null,
      onlyMine: true,
      fields: [
        {
          key: 'case',
          sortable: true,
        },
        { key: 'caseId' },
        { key: 'inCharge', sortable: true },
        { key: 'name', label: 'Task', sortable: true },
        { key: 'due', sortable: true },
      ],
      activeTasks: { nodes: [] },
      sortCompare(
        rowA: TaskNodeFragment,
        rowB: TaskNodeFragment,
        key: Column,
        formatter: (...args: any[]) => string,
        compareOptions: Intl.CollatorOptions,
        compareLocale: string | string[]
      ): number {
        if (key === 'case') {
          return compareStrings(rowA?.case?.patient?.alias, rowB?.case?.patient?.alias)
        }
        if (key === 'inCharge') {
          const aliasesA = rowA.candidates.nodes
            .map(candidate => candidate.caseMember?.alias)
            .filter(alias => !!alias)
            .sort()
          const aliasesB = rowB.candidates.nodes
            .map(candidate => candidate.caseMember?.alias)
            .filter(alias => !!alias)
            .sort()
          const comparisons = zip(aliasesA, aliasesB)
            .map(tuple => compareStrings(tuple[0], tuple[1], compareLocale, compareOptions))
            .filter(result => result !== 0)
          if (comparisons.length > 0) {
            return comparisons[0]
          } else {
            return 0
          }
        }
        if (key === 'name') {
          return compareStrings(rowA.name, rowB.name, compareLocale, compareOptions)
        }
        if (key === 'due') {
          return compareDates(rowA.due, rowB.due)
        }
        throw new Error(`unsupported key ${key}`)
      },
    }
  },
  methods: {
    log(something: any): void {
      console.log(wrapVariables(something))
    },
    nextPage(): void {
      this.page++
    },
    previousPage(): void {
      this.page = Math.max(0, this.page - 1)
    },
    refreshTaskList(): void {
      console.log('refresh task list')
      this.$apollo.queries.activeTasks.refresh()
      //this.$store.dispatch<FetchAction>({ type: 'workflow/fetch' })
    },
  },
})
